import Badge from '../ui/Badge';

interface UptimeStatusBadgeProps {
  isUp: boolean | null;
  isPaused?: boolean;
}

export default function UptimeStatusBadge({ isUp, isPaused = false }: UptimeStatusBadgeProps) {
  if (isPaused) {
    return <Badge tone="idle" dot>Paused</Badge>;
  }

  if (isUp === null) {
    return <Badge tone="idle">No Data</Badge>;
  }

  if (isUp) {
    return <Badge tone="up" dot>Up</Badge>;
  }

  return <Badge tone="down" dot pulse>Down</Badge>;
}
